import { CarrosselMarca } from './carrossel-marca';

/**
 * Lado da marca do login. Único `<h1>` da página — o `LoginForm` ao lado usa
 * `<h2>`.
 *
 * **Mobile**: só o SÍMBOLO da marca e a chamada, os dois centralizados. Não é
 * economia de espaço — é hierarquia: numa tela de 390px o que precisa aparecer
 * acima da dobra é o campo de e-mail, e tudo que fica entre a marca e ele
 * empurra o formulário para baixo. A logo completa (com "SPECIALIZER" e o
 * slogan) e o carrossel entram só a partir de `md`.
 *
 * Os três diferenciais e os três chips do rodapé viraram o `CarrosselMarca`:
 * a mesma informação, um item por vez, ~140px de altura a menos — que é o que
 * tirou o scroll do cartão em telas de 13 polegadas.
 */

export function BrandPanel(): JSX.Element {
  return (
    <section className="relative flex flex-col justify-center gap-6 p-7 text-center sm:p-9 md:p-11 md:text-left">
      <div>
        {/* Só o símbolo no mobile: a logo completa carrega o slogan da empresa,
            que compete com a chamada do produto logo abaixo. */}
        <img
          src={`${import.meta.env.BASE_URL}marca-specializer.png`}
          alt="Specializer"
          width={206}
          height={86}
          className="mx-auto h-auto w-[92px] shrink-0 md:hidden"
        />
        <img
          src={`${import.meta.env.BASE_URL}logo-specializer.png`}
          alt="Specializer"
          width={258}
          height={210}
          className="hidden h-auto w-[130px] shrink-0 md:block"
        />

        <h1 className="text-auth-texto mt-5 text-[clamp(1.5rem,2.6vw,2.4rem)] leading-[1.15] font-light tracking-tight text-balance md:mt-6">
          Contrato social sem erro.{' '}
          <em className="from-auth-marca-hover to-auth-acento bg-gradient-to-r bg-clip-text font-medium not-italic text-transparent">
            Já na primeira via.
          </em>
        </h1>

        <p className="text-auth-texto-secundario mt-4 hidden max-w-[46ch] text-sm leading-relaxed md:block">
          Auditoria e montagem de contrato social: a conferência roda sozinha, a alteração
          consolida sem redigitar, e o documento sai pronto para a Junta.
        </p>
      </div>

      <div className="hidden md:block">
        <CarrosselMarca />
      </div>
    </section>
  );
}
